import { useTranslation } from "react-i18next";
import OptionToggler from "../../OptionToggler";

const LoadToggler = ({
  isAssistant,
  preferredLoadInput,
  setPreferredLoadInput,
  tabIndex,
}) => {
  const { t } = useTranslation("coaching-portal");
  const options = [
    { value: "weight", label: t("addExerciseModal.weight") },
    { value: "drop", label: t("addExerciseModal.percentMod") },
  ];
  return (
    <div>
      <label htmlFor="loadType" className="invisible">
        {t("addExerciseModal.loadType")}
      </label>
      <OptionToggler
        name="loadType"
        defaultValue={preferredLoadInput}
        onSelectFn={setPreferredLoadInput}
        tabIndex={tabIndex}
        options={
          isAssistant
            ? options
            : [{ value: "percent", label: t("addExerciseModal.percent1RM") }, ...options]
        }
      />
    </div>
  );
};

export default LoadToggler;
